import { gwPost } from '../actionsFactory/gwRequest';
import API_PATH from '../actionsFactory/apiPath';
import { handleGwData, setPostBody } from '../actionsFactory';

const LOADING_STEP = {
  nextStep: 'LOADING',
};

export const preValidate = async params => {
  const { success, message } = (await gwPost(API_PATH.PRE_VALIDATE, setPostBody(params))) || {};
  if (!success) throw new Error(message);
  return true;
};

export const fetchNextStep = async params => {
  let result = LOADING_STEP;
  const { success, data, message } = await gwPost(API_PATH.FLOW_NEXT_STEP, setPostBody(params));
  if (!success) throw new Error(message);
  result = data || LOADING_STEP;
  return result;
};

export const fetchQuestionList = async params => {
  const { success, data, message } = await gwPost(API_PATH.GET_QUESTIONS, setPostBody(params));
  if (!success) throw new Error(message);
  return data;
};

export const answerQuestion = async params => {
  const data = await gwPost(API_PATH.ANSWER_QUESTION, setPostBody(params));
  return handleGwData(data);
};

export const verifyEmail = async params => {
  const { success, data, message } = await gwPost(API_PATH.FLOW_OPEN_EMAIL, setPostBody(params));
  if (!success) throw new Error(message);
  return data;
};

export default {};
